import React from "react";

import { Chip, useTheme } from "@mui/material";

import { baseChipStyle } from "../../Chip/Chip";

/**
 * A choice group's tally, set as a chip so it sits in the same slot as the
 * safety chips on the dish rows around it rather than as a second, quieter
 * voice saying the same kind of thing.
 *
 * The row's title carries the warning glyph when blocked, so this only takes
 * the colour. The words differ between states too, so the verdict never rests
 * on colour alone.
 */
export const MenuTreeChip = ({
  label,
  blocked = false,
}: {
  label: string;
  blocked?: boolean;
}) => {
  const {
    palette: { oscar, grey },
    typography,
  } = useTheme();

  return (
    <Chip
      label={label}
      sx={{
        "&&": {
          // A step darker than the option card these sit on, which is itself
          // one step off white: at the card's own tone the chip disappeared
          // into it.
          backgroundColor: blocked
            ? oscar.light.surface.danger
            : oscar.light.surface.gray,
          borderColor: grey[300],
          borderWidth: 0,
          borderStyle: "solid",
        },
        ...baseChipStyle,
        // The shared chips are single words on one line. These are sentences,
        // and a narrow phone would otherwise ellipsise a safety verdict
        // mid-clause.
        height: "auto",
        maxHeight: "none",
        minHeight: 32,
        paddingY: 0.5,
        ...typography.labelSMedium,
        color: blocked
          ? oscar.light.content.dangerText
          : oscar.light.content.content1,
        "& .MuiChip-label": {
          whiteSpace: "normal",
        },
      }}
    />
  );
};
